var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.147H3.906a2 2 0 0 1-2-2V7.16a2 2 0 0 1 2-2H9.5M19 19.147h5.494a2 2 0 0 0 2-2V7.16a2 2 0 0 0-2-2H18.5",
    stroke: "#7D80DA",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 8,
    height: 6,
    rx: 1,
    stroke: "#7D80DA",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.188,
    y: 13.619,
    width: 8.017,
    height: 8.257,
    rx: 1,
    stroke: "#7D80DA",
    strokeWidth: 2
  })));
};
export { SvgPrint as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyOCAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMCAxOS4xNDdIMy45MDZhMiAyIDAgMCAxLTItMlY3LjE2YTIgMiAwIDAgMSAyLTJIOS41TTE5IDE5LjE0N2g1LjQ5NGEyIDIgMCAwIDAgMi0yVjcuMTZhMiAyIDAgMCAwLTItMkgxOC41IiBzdHJva2U9IiM3RDgwREEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHJlY3QgeD0iMTAiIHk9IjEiIHdpZHRoPSI4IiBoZWlnaHQ9IjYiIHJ4PSIxIiBzdHJva2U9IiM3RDgwREEiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHJlY3QgeD0iMTAuMTg4IiB5PSIxMy42MTkiIHdpZHRoPSI4LjAxNyIgaGVpZ2h0PSI4LjI1NyIgcng9IjEiIHN0cm9rZT0iIzdEODBEQSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";